import { render, staticRenderFns } from "./organizationGroup.vue?vue&type=template&id=5229a4d3&scoped=true"
import script from "./organizationGroup.vue?vue&type=script&lang=js"
export * from "./organizationGroup.vue?vue&type=script&lang=js"
import style0 from "./organizationGroup.vue?vue&type=style&index=0&id=5229a4d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5229a4d3",
  null
  
)

export default component.exports